(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('VendorDueDiligenceDocumentsController', VendorDueDiligenceDocumentsController);

  /* ngInject */
  function VendorDueDiligenceDocumentsController($location, $stateParams, vendorDueDiligenceDocumentService, sessionService) {
    const vm = this;

    vm.activate = activate;
    vm.getVendorDueDiligenceDocuments = getVendorDueDiligenceDocuments;
    vm.loading = false;
    vm.vendorDueDiligenceDocuments = [];
    vm.viewType = $stateParams.viewType || 'list';
    vm.viewTypeChanged = viewTypeChanged;
    vm.orderBy = orderBy;
    vm.order = '-created_at';

    activate();

    function activate() {
      getVendorDueDiligenceDocuments();
    }

    function getVendorDueDiligenceDocuments() {
      vm.loading = true;
      vendorDueDiligenceDocumentService(sessionService.getAuthToken()).query({}, _getVendorDueDiligenceDocumentsSuccess);
    }

    function orderBy(field) {
      if (vm.order.includes(field)) {
        if (vm.order.substr(0, 1) == '-') {
          vm.order = field;
        } else {
          vm.order = '-' + field;
        }
      } else {
        vm.order = field;
      }
    }

    function _getVendorDueDiligenceDocumentsSuccess(response) {
      vm.loading = false;
      vm.vendorDueDiligenceDocuments = response.data;
    }

    function viewTypeChanged(viewType) {
      vm.viewType = viewType;
      $location.search('viewType', viewType);
    }
  }
})();
